/* eslint-disable @typescript-eslint/no-use-before-define */
import { type ReactNode } from 'react';
import * as React from 'react';
import styled from 'styled-components';

import { ArrowRightIcon } from '../../icons/Icons';
import { Button, Heading, Text } from '../design-system';

const Wrapper = styled.div<{ $orientation: string }>`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const Icon = styled.div<{ $large?: boolean }>`
  display: flex;
  flex: none;
  height: ${({ $large }) => ($large ? '34px' : '26px')};
  width: 15px;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;

  svg {
    color: ${({ theme }) => theme.colors.LIGHT_PURPLE};
  }
`;

const Top = styled.div<{ $large?: boolean }>`
  display: flex;
  gap: ${({ $large }) => ($large ? '12px' : '10px')};
  position: relative;
  z-index: 1;
  min-width: 0;
`;

const Description = styled(Text)`
  margin-bottom: 7px;
`;

export interface TextLockupProps {
  cta?: string;
  description?: ReactNode;
  icon?: ReactNode;
  link?: string;
  orientation?: 'horizontal' | 'vertical';
  showLearnMore?: boolean;
  size?: 'default' | 'large';
  title: string;
}

export const TextLockup: React.ComponentType<TextLockupProps> = React.memo(
  ({
    orientation = 'horizontal',
    icon,
    title,
    description,
    link,
    showLearnMore = true,
    cta = 'Learn more',
    size = 'default'
  }) => {
    return (
      <Wrapper $orientation={orientation}>
        <Top $large={size === 'large'}>
          {icon && <Icon $large={size === 'large'}>{icon}</Icon>}
          <Heading renderAs={size === 'large' ? 'h3' : 'h4'}>{title}</Heading>
        </Top>
        {description && (
          <Description size={size === 'large' ? 'large' : 'medium'}>
            {description}
          </Description>
        )}
        {link && showLearnMore && (
          <Button
            icon={<ArrowRightIcon />}
            iconPos="right"
            link={link}
            size="small"
            text={cta}
          />
        )}
      </Wrapper>
    );
  }
);
